import ActionType from 'actions/ActionType'

export default (state = 'scheduled', action) => {
  switch (action.type) {
    case ActionType.Tasks.CHANGE_AUTOMATION_TYPE:
      return action.payload
    case ActionType.Tasks.RECEIVE_TASK:
      if (action.payload && action.payload.owned_by) {
        if (action.payload.owned_by.type === 'S') {
          return 'stage'
        }

        if (action.payload.owned_by.type === 'C') {
          return 'calendar'
        }
      }

      return 'scheduled'
    default:
      return state
  }
}
